/* eslint-disable @typescript-eslint/no-var-requires */
/* eslint-disable global-require */
import React, { forwardRef } from 'react';

import 'moment/locale/pt-br';

import { Container } from './styles';
import { Paper, styled, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import { Data } from '../../../pages/Historico/OrderTable';
import mask from '../../../utils/mask';

interface ComponentToPrintProps {
  pedidos: Data[];
}

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  // [`&.${tableCellClasses.head}`]: {
  //   backgroundColor: theme.palette.common.black,
  //   color: theme.palette.common.white,
  // },
  // [`&.${tableCellClasses.body}`]: {
  //   fontSize: 14,
  // },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));

const estagios = [
  'Aguardo',
  'Aceito',
  'Negado',
  'Preparação',
  'Pronto',
  'Rota Entrega',
  'Entregue',
  'Faturado',
  'Separado',
  'Cancelado',
  'Cancelado Cliente',
  'Pronto retirada',
];

const ComponentToPrintReport = forwardRef<HTMLDivElement, ComponentToPrintProps>(
  (props, ref) => {

    return (
      <Container ref={ref}>
        <TableContainer component={Paper}>
          <Table aria-label="customized table">
            <TableHead>
              <TableRow>
                <StyledTableCell align="left">Pedido</StyledTableCell>
                <StyledTableCell align="left">Data</StyledTableCell>
                <StyledTableCell align="left">Cliente</StyledTableCell>
                <StyledTableCell align="left">Telefone</StyledTableCell>
                <StyledTableCell align="left">Pagamento</StyledTableCell>
                <StyledTableCell align="left">Estágio</StyledTableCell>
                <StyledTableCell align="left">Valor Total</StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {props.pedidos.slice(0, 100).map((row) => (
                <StyledTableRow key={`${row}`}>
                  <StyledTableCell align="left">{row.pedido}</StyledTableCell>
                  <StyledTableCell align="left">{row.data}</StyledTableCell>
                  <StyledTableCell align="left">{row.cliente}</StyledTableCell>
                  <StyledTableCell align="left">
                    {
                      row.fone.length === 11
                        ? mask(row.fone, '(##) #####-####')
                        : mask(row.fone, '(##) ####-####')
                    }
                  </StyledTableCell>
                  <StyledTableCell align="left">{row.pagamento}</StyledTableCell>
                  <StyledTableCell align="left">{estagios[row.estagio || 0]}</StyledTableCell>
                  <StyledTableCell align="left">{row.valortotal}</StyledTableCell>
                </StyledTableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Container>
    );
  },
);

export default ComponentToPrintReport;
